"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _store = require("../../redux/store");
var _giftSlice = require("../../redux/giftSlice");
var _offerSlice = require("../../redux/offerSlice");
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _Button = _interopRequireDefault(require("../Button"));
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _MyAccountInput = _interopRequireDefault(require("../MyAccountInput"));
var _OfferCheckoutCard = _interopRequireDefault(require("../OfferCheckoutCard"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _auth = _interopRequireDefault(require("../../services/auth"));
var _ErrorPage = _interopRequireDefault(require("../ErrorPage"));
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _ThankYouPage = _interopRequireDefault(require("./ThankYouPage"));
var _RedeemGift = require("./RedeemGift.styled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RedeemGift = _ref => {
  let {
    onBackClick,
    onSuccess
  } = _ref;
  const [giftCode, setGiftCode] = (0, _react.useState)('');
  const [showOffer, setShowOffer] = (0, _react.useState)(false);
  const [isGiftRedeemed, setIsGiftRedeemed] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const {
    error,
    isRedeemLoading,
    isVerifyLoading,
    verifiedGift: {
      redeemable
    }
  } = (0, _store.useAppSelector)(_giftSlice.selectGift);
  const {
    loading: isOfferLoading
  } = (0, _store.useAppSelector)(_offerSlice.selectOffer);
  const handleChange = e => setGiftCode(e.target.value);
  const handleVerifyGift = async () => {
    const {
      offerId
    } = await dispatch((0, _giftSlice.fetchVerifyGift)(giftCode)).unwrap().catch(err => {
      setShowOffer(false);
      throw new Error(err);
    });
    if (offerId) {
      setShowOffer(true);
      await dispatch((0, _offerSlice.fetchOffer)(offerId));

      // fetching offer V2 for offerTitle in case fetchOffer above returns e.g. georestriction
      await dispatch((0, _offerSlice.fetchOfferV2)(offerId.split('_')[0]));
    }
  };
  const handleRedeemGift = async () => {
    await dispatch((0, _giftSlice.fetchRedeemGift)(giftCode)).unwrap().catch(err => {
      throw new Error(err);
    });
    setIsGiftRedeemed(true);
  };
  (0, _react.useEffect)(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const giftCodeParam = urlParams.get('giftCode');
    if (giftCodeParam) {
      setGiftCode(giftCodeParam);
    }
  }, [window.location.search]);
  (0, _react.useEffect)(() => {
    let timer;
    if (isGiftRedeemed) {
      timer = setTimeout(() => {
        onSuccess();
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isGiftRedeemed]);
  const isConfirmButtonDisabled = !redeemable || isVerifyLoading || isOfferLoading;
  const renderMainContent = () => {
    if (!_auth.default.isLogged()) {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_AUTH_FAILED, {
        source: 'RedeemGift'
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorPage.default, {
        type: "isNotAuth",
        isRedeemGift: true
      });
    }
    if (isGiftRedeemed) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPage.default, {});
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_RedeemGift.RedeemGiftWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
          center: true,
          paddingBottom: "10px",
          children: t('redeem-gift.button.header', 'Redeem your gift')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RedeemGift.InputWrapperStyled, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
            error: error,
            onChange: handleChange,
            name: "giftCode",
            type: "text",
            value: giftCode,
            placeholder: "XXXX-XXXX"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            disabled: !giftCode,
            theme: "confirm",
            onClickFn: handleVerifyGift,
            children: isVerifyLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) : t('redeem-gift.button.verify', 'Verify')
          })]
        }), showOffer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedeemGift.OfferWrapperStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferCheckoutCard.default, {
            isRedeemGift: true
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          disabled: isConfirmButtonDisabled,
          theme: "confirm",
          onClickFn: handleRedeemGift,
          children: isRedeemLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#ffffff"
          }) : t('redeem-gift.button.confirm', 'Confirm & proceed')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RedeemGift.WrapperStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
      onBackClick: onBackClick
    }), renderMainContent()]
  });
};
var _default = exports.default = RedeemGift;